import styled from 'styled-components';

import style from '../../../style';
import type { Size } from '../../../style/types/theme';
import type { InputWrapperProps } from '../Common.styled';
import { BorderRadiusSize, Status } from '../types';
import { getInputColors } from '../Common.styled';

interface TextareaWrapperProps extends Omit<InputWrapperProps, '$size'> {
  $borderRadiusSize: BorderRadiusSize;
  $isFocused: boolean;
  $width?: string;
}

const getBorderRadiusSize = (size: Size, borderRadiusSize?: BorderRadiusSize) => {
  switch (borderRadiusSize) {
    case BorderRadiusSize.NONE:
      return 0;
    case BorderRadiusSize.SMALL:
      return size.units(0.5);
    case BorderRadiusSize.BIG:
      return size.units(2);
    case BorderRadiusSize.MEDIUM:
    default:
      return size.units(1);
  }
};

export const TextareaWrapper = styled.div<TextareaWrapperProps>(
  ({
    theme: { size, color, transition },
    $status,
    $disabled,
    $borderRadiusSize,
    $isFocused,
    $width,
  }) => ({
    display: 'flex',
    border: `1px solid ${
      $disabled
        ? color.border.primary.disabled()
        : getInputColors($status, color).borderColor
    }`,
    borderRadius: getBorderRadiusSize(size, $borderRadiusSize),
    padding: `${size.units(1)} ${size.units(1)} ${size.units(1)} ${size.units(1.5)}`,
    transition: transition.standard('border', 'color'),
    backgroundColor: $disabled
      ? color.background.primary.disabled()
      : color.background.primary.default(),
    width: $width,

    ...($isFocused && {
      borderColor:
        $status === Status.DEFAULT
          ? color.border.accent.default()
          : getInputColors($status, color).borderColor,
    }),

    ...style.mixins.devices.desktop(
      !$isFocused
        ? {
            ':hover': {
              borderColor: $disabled
                ? undefined
                : getInputColors($status, color).hoverBorderColor,
            },
          }
        : {},
    ),
  }),
);
